import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, Teleport as _Teleport, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-expanded", "title", "aria-label"]
const _hoisted_2 = { class: "bell-label" }
const _hoisted_3 = {
  key: 0,
  class: "unread-dot",
  "aria-hidden": "true"
}
const _hoisted_4 = { class: "dialog-header" }
const _hoisted_5 = { id: "announcement-dialog-title" }
const _hoisted_6 = ["aria-label", "title"]

import { defineAsyncComponent, nextTick, onMounted, onBeforeUnmount, ref } from "vue";
import { useI18n } from "vue-i18n";
import { unreadCount, refreshAnnouncements, syncReadState, readStorageKey } from "@/services/announcements";

export default /*@__PURE__*/_defineComponent({
  __name: 'AnnouncementBell',
  setup(__props) {

const { t } = useI18n({ useScope: "global" });
const AnnouncementReader = defineAsyncComponent(() => import("@/views/Announcements/Announcements.vue"));
const dialog = ref<HTMLDialogElement | null>(null);
const trigger = ref<HTMLButtonElement | null>(null);
const open = ref(false);
async function showAnnouncements() {
  open.value = true;
  await nextTick();
  if (open.value && dialog.value && !dialog.value.open) dialog.value.showModal();
}
function closeAnnouncements() {
  dialog.value?.close();
  open.value = false;
  trigger.value?.focus();
}
function onBackdropClick(event: MouseEvent) {
  if (event.target !== dialog.value || !dialog.value) return;
  const bounds = dialog.value.getBoundingClientRect();
  if (event.clientX < bounds.left || event.clientX > bounds.right ||
      event.clientY < bounds.top || event.clientY > bounds.bottom) closeAnnouncements();
}
let timer: number | undefined;
function refresh() {
  if (document.visibilityState === "visible") void refreshAnnouncements();
}
function onStorage(event: StorageEvent) {
  if (event.key === readStorageKey || event.key === null) syncReadState();
}
onMounted(() => {
  refresh();
  timer = window.setInterval(refresh, 300000);
  window.addEventListener("focus", refresh);
  document.addEventListener("visibilitychange", refresh);
  window.addEventListener("storage", onStorage);
});
onBeforeUnmount(() => {
  window.clearInterval(timer);
  window.removeEventListener("focus", refresh);
  document.removeEventListener("visibilitychange", refresh);
  window.removeEventListener("storage", onStorage);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      ref_key: "trigger",
      ref: trigger,
      type: "button",
      class: "announcement-bell",
      "aria-haspopup": "dialog",
      "aria-expanded": open.value,
      onClick: showAnnouncements,
      title: _unref(t)('announcements.title'),
      "aria-label": _unref(unreadCount) ? _unref(t)('announcements.unreadCount', { count: _unref(unreadCount) }) : _unref(t)('announcements.title')
    }, [
      _cache[3] || (_cache[3] = _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        "aria-hidden": "true"
      }, [
        _createElementVNode("path", { d: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" })
      ], -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('announcements.title')), 1),
      (_unref(unreadCount))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("dialog", {
        ref_key: "dialog",
        ref: dialog,
        class: "announcement-dialog",
        "aria-labelledby": "announcement-dialog-title",
        onCancel: _withModifiers(closeAnnouncements, ["prevent","stop"]),
        onClose: _cache[0] || (_cache[0] = ($event: any) => (open.value = false)),
        onClick: onBackdropClick,
        onKeydown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
        onKeyup: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("header", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(t)('announcements.title')), 1),
          _createElementVNode("button", {
            type: "button",
            class: "dialog-close",
            autofocus: "",
            "aria-label": _unref(t)('announcements.close'),
            title: _unref(t)('announcements.close'),
            onClick: closeAnnouncements
          }, "×", 8, _hoisted_6)
        ]),
        (open.value)
          ? (_openBlock(), _createBlock(_unref(AnnouncementReader), {
              key: 0,
              class: "dialog-reader"
            }))
          : _createCommentVNode("", true)
      ], 544)
    ]))
  ], 64))
}
}

})